import { useEffect, useRef } from 'preact/hooks'
import SwiperInstanceComponent from 'customs/swiper-instance-component'
import Icon from 'snippets/icon/icon'

export default function CarouselSwiper({
  title,
  titleClass = 'text-xl font-semibold text-grey-900 lg:text-3xl',
  children,
  classWrapper,
  className,
  classNavigation = '',
  selector,
  options,
  ctaText,
  ctaLink,
  enableCenter = false,
  navigation = false,
  pagination = false,
  scrollbar = false,
  keyboard = false,
  thumbnail = null,
  zoom = false,
  mousewheel = false,
  freeMode = false
}) {
  const config = { navigation, pagination, scrollbar, keyboard, thumbnail, zoom, mousewheel, freeMode }
  const swiperRef = useRef(null)

  useEffect(() => {
    const currentOptions = {
      ...options,
      on: {
        init: () => {
          swiperRef.current.classList.add('swiper-initialized')
        }
      }
    }

    const carouselInstance = new SwiperInstanceComponent(swiperRef.current, currentOptions, config, 'component')
  }, [])

  return (
    children && (
      <div className={`swiper-wrapper ${classWrapper}`} ref={swiperRef} data-selector={selector} data-type="component">
        <div className={`flex items-start justify-between ${title ? 'mb-4 lg:mb-6' : ''} ${enableCenter ? 'lg:!mb-8' : ''}`}>
          {title && !enableCenter &&
            <div className="flex items-center gap-4">
              <h2 className={titleClass}>{title}</h2>
              {ctaText && ctaLink &&
                <a href={ctaLink} className="text-base border-b font-bold border-grey-900 transition-all duration-300 md-max:hidden hover:text-accent-1 hover:border-accent-1">{ctaText}</a>
              }
            </div>
          }
          {navigation && (
            <div className={`flex items-center gap-2 ${title ? 'swiper-navigation-custom' : ''} ${classNavigation} ${enableCenter ? 'w-full justify-between' : 'ml-auto '}`}>
              <button
                className="swiper-button-prev js-carousel-prev"
                type="button"
                aria-label="Previous slide"
              >
                <Icon name="icon-chevron-left" className="size-5" viewBox="0 0 20 20"/>
              </button>
              {title && enableCenter &&
                <div className="flex items-center gap-4">
                  <h2 className={titleClass}>{title}</h2>
                  {ctaText && ctaLink &&
                    <a href={ctaLink} className="text-base border-b font-bold border-grey-900 md-max:hidden hover:text-accent-1 hover:border-accent-1">{ctaText}</a>
                  }
                </div>
              }
              <button
                className="swiper-button-next js-carousel-next"
                type="button"
                aria-label="Next slide"
              >
                <Icon name="icon-chevron-right" className="size-5" viewBox="0 0 20 20"/>
              </button>
            </div>
          )}
        </div>
        <swiper-container className={`swiper ${className} ${selector}`} init="false">
          {children}
        </swiper-container>
        {pagination && <div class="swiper-pagination js-carousel-pagination"></div>}
        {scrollbar && <div class="swiper-scrollbar js-carousel-scrollbar"></div>}
      </div>
    )
  )
}
